import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "name", "id", "disabled", "aria-describedby"]

import { useInputModel } from '@src/components/shared/form_elements/useInputModel';

interface Props {
	modelValue: boolean | null;
	name: string;
	inputId: string;
	disabled?: boolean;
	required?: boolean;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxToggle',
  props: {
    modelValue: { type: [Boolean, null] },
    name: {},
    inputId: {},
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue' ],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const inputModel = useInputModel<boolean>( () => props.modelValue, props.modelValue, emit );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", null, [
    _renderSlot(_ctx.$slots, "default"),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null)),
      value: _unref(inputModel),
      type: "checkbox",
      class: "toggle",
      name: __props.name,
      id: __props.inputId,
      disabled: __props.disabled,
      "aria-describedby": __props.ariaDescribedby
    }, null, 8, _hoisted_1), [
      [_vModelCheckbox, _unref(inputModel)]
    ])
  ]))
}
}

})